import React from 'react';
import ModalContainer from 'components/Modal/ModalContainer/ModalContainer';
import { useStyles } from './TextImageModal.styles';
import { INonReactModalData } from 'interfaces/modal';
import { useModalData } from 'hooks/useModalData';
import TextImageModalSkeleton from './Skeleton/TextImageModalSkeleton';
import TextImageModalBase from 'components/Modal/TextImageModalBase/TextImageModalBase';

interface ITextImageModal {
  closeFunction: () => void;
  isOpen: boolean;
  id: string;
  isFutureContent?: boolean;
}

const TextImageModal = ({
  closeFunction,
  isOpen,
  id,
  isFutureContent,
}: ITextImageModal): JSX.Element => {
  const queryKey = `/platform/api/v1/components/modal?id=${id}${
    isFutureContent ? '&FutureContentEnabled=true' : ''
  }`;

  const { status, data } = useModalData(queryKey);
  const modal: INonReactModalData = data as INonReactModalData;
  const classes = useStyles();

  return (
    <ModalContainer
      isNotReact
      closeFunction={closeFunction}
      isOpen={isOpen}
      title={data?.headline ? data.headline : 'Loading modal'}
      className={classes.paper}
      noTracking
    >
      {checkStatus()}
    </ModalContainer>
  );

  function checkStatus(): JSX.Element {
    switch (status) {
      case 'error':
        return <span className="error">Error</span>;
      case 'success':
        return <TextImageModalBase modal={modal} outOfReact />;
      default:
        return <TextImageModalSkeleton />;
    }
  }
};

export default TextImageModal;
